export type BrandLogo = {
  logoBw?: string;
  logoColor?: string;
  aspectRatio: string; // eg '2 / 1'
};

interface BrandLogos {
  [key: string]: BrandLogo;
}

export const brandLogos: BrandLogos = {
  netatmo: {
    logoBw: '/content/content-images/brand-logos/f35633d4bdf7463973f6a67282b3b012/netatmo-sw.svg',
    logoColor:
      '/content/content-images/brand-logos/color/1ac66e499b3411aca5c95930367635ea/netatmo-kl.svg',
    aspectRatio: '135 / 24',
  },
  omajin: {
    logoBw:
      '/content/content-images/brand-logos/66e93b8db095d31b35e4267710e4ec85/omajin-by-netatmo.svg',
    logoColor:
      '/content/content-images/brand-logos/color/a8b0eb0ee870a07adacc320e3b8625c6/omajin-by-netatmo-color.svg',
    aspectRatio: '146 / 54',
  },
  'omajin-by-netatmo': {
    logoBw:
      '/content/content-images/brand-logos/66e93b8db095d31b35e4267710e4ec85/omajin-by-netatmo.svg',
    logoColor:
      '/content/content-images/brand-logos/color/a8b0eb0ee870a07adacc320e3b8625c6/omajin-by-netatmo-color.svg',
    aspectRatio: '146 / 54',
  },
  'd-link': {
    logoBw: '/content/content-images/brand-logos/5c1c1682dabab059c559c27d6b3fbaa8/d-link-logo.svg',
    aspectRatio: '108 / 24',
  },
  'philips-hue': {
    logoBw:
      '/content/content-images/brand-logos/ab4677eb3f33c3922d92730430b431b5/philips-hue-sw.svg',
    logoColor:
      '/content/content-images/brand-logos/color/9d2cd736bfe1795dade216f2db5dab82/philips-hue-2.svg',
    aspectRatio: '146 / 18',
  },
  philips: {
    logoBw: '/content/content-images/brand-logos/c93da5d5ad05a761cec3090d51dd59bc/philips.svg',
    logoColor:
      '/content/content-images/brand-logos/color/b92a867f5181b969008c9afba2a90279/philips-color.svg',
    aspectRatio: '88 / 16',
  },
  'smabit-bitron-video': {
    logoBw:
      '/content/content-images/brand-logos/a42857b956764231ca7b3ec954372f71/bitron-video-sw.svg',
    logoColor:
      '/content/content-images/brand-logos/color/92cfa015cd21ea2eafec81278f017969/bitron-video.svg',
    aspectRatio: '126 / 24',
  },
  schellenberg: {
    logoBw:
      '/content/content-images/brand-logos/f00c97eceb88ceed31912eb6c27f42b4/schellenberg-sw.svg',
    logoColor:
      '/content/content-images/brand-logos/color/3645befedd44b8159477f93c9241276d/schellenberg.svg',
    aspectRatio: '94 / 24',
  },
  tado: {
    logoBw: '/content/content-images/brand-logos/39554a3da1365a2e516a48847ca35811/tado.svg',
    aspectRatio: '244 / 86',
  },
  gardena: {
    logoBw: '/content/content-images/brand-logos/0722f0733f152cad8c1d3d845535ab95/gardena-sw.svg',
    logoColor:
      '/content/content-images/brand-logos/color/7f896f7aab92f3b1cd04b6d5341359c9/gardena.svg',
    aspectRatio: '85 / 18',
  },
  'paul-neuhaus': {
    logoBw:
      '/content/content-images/brand-logos/479b2f78e96dd033285fbf01a71a7e0c/neuhaus-lighting-group-sw.svg',
    logoColor:
      '/content/content-images/brand-logos/color/1bbeec1471d9d1e642d19776d5afcb8b/neuhaus-lighting-group@2x.png',
    aspectRatio: '75 / 24',
  },
  tint: {
    logoBw:
      '/content/content-images/brand-logos//e2cd6da47a1c6a4c558be11508912e8b/tint-logo-sw.svg',
    logoColor:
      '/content/content-images/brand-logos/color/8ce55254bac492d6302d621056ec0412/tint-logo.svg',
    aspectRatio: '197 / 235',
  },
  'homematic-ip': {
    logoBw: '/content/content-images/brand-logos/fe4b37ef1346f53d29e377fb3ebf7575/homematic-ip.svg',
    logoColor:
      '/content/content-images/brand-logos/color/e70a5bcd31ebc366bb94bdd76b8951ef/homematic-ip-color.svg',
    aspectRatio: '40 / 6',
  },
  ledvance: {
    logoBw:
      '/content/content-images/brand-logos/752391b0409068cd85ee73612ac7c52c/logo-ledvance-sw.svg',
    logoColor:
      '/content/content-images/brand-logos/color/03a1719163e4384d62afc2bc80c56946/logo-ledvance.svg',
    aspectRatio: '73 / 12',
  },
  wiz: {
    logoBw: '/content/content-images/brand-logos/06fa298ce73eb4bc67108530ab18cbb2/wiz-sw.svg',
    logoColor:
      '/content/content-images/brand-logos/color/8bb71c6810d2f293a484ee135d3b37af/WiZ-logo.svg',
    aspectRatio: '63 / 24',
  },
  nuki: {
    logoBw: '/content/content-images/brand-logos/69bc67ba360ff6c6e8bd176ec40b3c9e/nuki-sw.svg',
    logoColor:
      '/content/content-images/brand-logos/color/73bb708ab484aebd6610139936522ccf/nuki.svg',
    aspectRatio: '59 / 26',
  },
  telekom: {
    logoColor: '/content/content-images/brand-logos/fafa4a0dc25b7d273f5fb144598507d1/t-logo.svg',
    aspectRatio: '15 / 18',
  },
  smarthome: {
    logoColor: '/content/content-images/brand-logos/fafa4a0dc25b7d273f5fb144598507d1/t-logo.svg',
    aspectRatio: '15 / 18',
  },
  eurotronic: {
    logoBw: '/content/content-images/brand-logos/1196fb20543ddc6f74c7215c479ac32e/eurotronic.svg',
    logoColor:
      '/content/content-images/brand-logos/color/f7a1e9ed5c2d2d81f6a1282b1d7996f9/eurotronic-logo.svg',
    aspectRatio: '31 / 18',
  },
  varta: {
    logoBw:
      '/content/content-images/brand-logos/ff3160f6f0103842f82da4b80ef362e7/logo-varta-sw.svg',
    logoColor:
      '/content/content-images/brand-logos/color/dc81514b7a05a6a324111ecc54481e4d/logo-varta.svg',
    aspectRatio: '150 / 24',
  },
  intenso: {
    logoBw: '/content/content-images/brand-logos/2c23e46f1072ed8d816e3969f7a01269/intenso.svg',
    aspectRatio: '100 / 24',
  },
  ekey: {
    logoBw: '/content/content-images/brand-logos/2df3cd254eecc4100a3bf89907bccc69/ekey-logo-sw.png',
    logoColor:
      '/content/content-images/brand-logos/7862e0662b5abbec58b3d434dc02b626/ekey-logo-color.svg',
    aspectRatio: '97 / 24',
  },
  amazon: {
    logoBw: '/content/content-images/brand-logos/d57d6584dfc47ee8e23a285a5d4b8e61/logo-amazon.svg',
    logoColor:
      '/content/content-images/brand-logos/color/007796d638b0b6f5224041c20a259b18/amazon-farbe.svg',
    aspectRatio: '81 / 24',
  },
  ikea: {
    logoBw:
      '/content/content-images/brand-logos/614bc03ac68855f7c86a0783e907d806/ikea-logo-svg-vector.svg',
    logoColor:
      '/content/content-images/brand-logos/color/eb7482e63eff54c046b341c89405f7f4/ikea-logo-color.png',
    aspectRatio: '193 / 193',
  },
  eufy: {
    logoBw: '/content/content-images/brand-logos//779f9f9395c194db2c36ab40165dac40/eufy-logo.svg',
    aspectRatio: '41 / 20',
  },
  hama: {
    logoBw: '/content/content-images/brand-logos/ff7a7b0893171e2cc5a1a2d79136a08d/hama-logo-sw.svg',
    logoColor:
      '/content/content-images/brand-logos/color/a243cb88d97cbff213af2922c17d2e3c/hama-logo-color.svg',
    aspectRatio: '132 / 35',
  },
  xiaomi: {
    logoBw:
      '/content/content-images/brand-logos/34b61559b75d86f5f79434c882b6d0b5/xiaomi-logo-sw.svg',
    logoColor:
      '/content/content-images/brand-logos/color/1bf1809f7207f8fff5c8585c50373d19/xiaomi-logo-color.svg',
    aspectRatio: '20 / 20',
  },
  mika: {
    logoBw: '/content/content-images/brand-logos/dda2754d72fc7eaccbbbb1675a17cb45/VREEDA_Logo.svg',
    logoColor:
      '/content/content-images/brand-logos/dda2754d72fc7eaccbbbb1675a17cb45/VREEDA_Logo.svg',
    aspectRatio: '906 / 174',
  },
  aura: {
    logoBw:
      '/content/content-images/brand-logos/269f53d4cd16ed738fe18a7fd774bc00/aura_logo_black.png',
    aspectRatio: '505 / 106',
  },
  imou: {
    logoBw:
      '/content/content-images/brand-logos/040ea03edbfa9d21f77912ef77bf9308/imou_logo_black.svg',
    logoColor:
      '/content/content-images/brand-logos/733a106268827c947e39b8a756134f25/imou-logo-color.png',
    aspectRatio: '24 / 6',
  },
  eve: {
    logoBw: '/content/content-images/brand-logos/a184c792f1b1211f6d04d4b6b47bea03/eve.svg',
    logoColor: '/content/content-images/brand-logos/a184c792f1b1211f6d04d4b6b47bea03/eve.svg',
    aspectRatio: '63 / 24',
  },
  asus: {
    logoBw:
      '/content/content-images/brand-logos/f73f5dedda1f4c635179843558259de2/ASUS_Logo-min.svg',
    aspectRatio: '500 / 107',
  },
  avm: {
    logoBw: '/content/content-images/brand-logos/e2383603ce192ed7bbce66825f59e834/avm-sw-min.svg',
    logoColor:
      '/content/content-images/brand-logos/3b866fde632c5194c1b483a1d13b53da/AVM-Logo-min.svg',
    aspectRatio: '439 / 253',
  },
  belkin: {
    logoBw: '/content/content-images/brand-logos/5ccbffbcd8f050dd0d9ea35ec1aec47c/belkin.svg',
    aspectRatio: '101 / 28',
  },
  alcatel: {
    logoBw:
      '/content/content-images/brand-logos/77b2df297a74d9ea4661b13e56f18df7/alcatel-sw-min.svg',
    logoColor:
      '/content/content-images/brand-logos/93a22e30785e3642d64ce872abb407e0/Alcatel_Logo_last-min.svg',
    aspectRatio: '1063 / 392',
  },
  dell: {
    logoBw: '/content/content-images/brand-logos/b3d1a9521990b0253d4417f35598a65f/dell-sw-min.svg',
    logoColor:
      '/content/content-images/brand-logos/5eea7fa6a3090b9f742e651b1aff8b66/Dell_logo-min.svg',
    aspectRatio: '400 / 127',
  },
  fairphone: {
    logoBw:
      '/content/content-images/brand-logos/83a64b25939c92311e280e042dfd8468/fairphone-logo.svg',
    aspectRatio: '190 / 44',
  },
  nokia: {
    logoBw: '/content/content-images/brand-logos/697889f50109ffa535b2a1cf4f18beb4/nokia-sw-min.svg',
    logoColor:
      '/content/content-images/brand-logos/7b56f4032a220f3a81187e106ca53e9c/Nokia_wordmark-min.svg',
    aspectRatio: '313 / 53',
  },
  google: {
    logoBw:
      '/content/content-images/brand-logos/88d420f268428d3eb184d38c34dacaf7/google-sw-min.svg',
    logoColor:
      '/content/content-images/brand-logos/7bbed22984d4cbfb6f7645177044af42/Google_2015_logo-min.svg',
    aspectRatio: '270 / 90',
  },
  poly: {
    logoBw: '/content/content-images/brand-logos/7f9529c70ac77ec60003ad9fcf8cb6fa/poly-sw-min.svg',
    logoColor:
      '/content/content-images/brand-logos/8438caebdf2acf9c4ece3d6bab05ceee/Poly_Inc._Logo-min.svg',
    aspectRatio: '381 / 166',
  },
  teufel: {
    logoBw:
      '/content/content-images/brand-logos/da40a90ac29a568f36697faa47c42e56/teufel-sw-min.svg',
    logoColor:
      '/content/content-images/brand-logos/61b8048e206bd19fdaa07d3251110958/Lautsprecher_Teufel_Logo-min.svg',
    aspectRatio: '710 / 261',
  },
  reolink: {
    logoBw: '/content/content-images/brand-logos/57d59ea4f27dad6fd7d6ef921d3a0cd6/Reolink-min.svg',
    aspectRatio: '1565 / 365',
  },
  spigen: {
    logoBw:
      '/content/content-images/brand-logos/135dc2f82f74ed500d19c6c11989f98c/spigen-sw-min.svg',
    logoColor:
      '/content/content-images/brand-logos/df8e44cc67d9737e1c1f110fc6b504c3/Spigen_logo-min.svg',
    aspectRatio: '584 / 127',
  },
  samsung: {
    logoBw:
      '/content/content-images/brand-logos/e180e132a0eb2a8521d02489bc60e07c/samsung-sw-min.svg',
    logoColor:
      '/content/content-images/brand-logos/09d9f03393a8c3c74ad06e8b283a433f/Samsung_wordmark-min.svg',
    aspectRatio: '1934 / 298',
  },
  zte: {
    logoBw: '/content/content-images/brand-logos/080bb6accf1756a3a5c452a19261dcbb/ZTE-sw-min.svg',
    aspectRatio: '427 / 207',
  },
  nothing: {
    logoBw: '/content/content-images/brand-logos//8b42e94caa01350ca62d308296771e7b/Nothing-min.svg',
    aspectRatio: '99.02 / 17.78',
  },
  sandisk: {
    logoBw:
      '/content/content-images/brand-logos/71b317660455b5f0ce7331eb6db320c2/sandisk-sw-min.svg',
    logoColor:
      '/content/content-images/brand-logos/5f0251ef1d389fddffac769c71f1692a/SanDisk_Logo_2007-min.svg',
    aspectRatio: '688 / 138',
  },
  agood: {
    logoBw:
      '/content/content-images/brand-logos/d320753f56b6f2f2e74a58be5b447b43/agood-logo-sw-min.svg',
    aspectRatio: '342 / 48',
  },
  anker: {
    logoBw: '/content/content-images/brand-logos/3f16669f1187d9320ce575c8231f3de1/anker-sw-min.svg',
    logoColor: '/content/content-images/brand-logos/88a51adaef5a7ad519b8a089b683f22b/anker-min.svg',
    aspectRatio: '200 / 48',
  },
  apple: {
    logoBw: '/content/content-images/brand-logos/5c6533b9f740ac15efa390058a8c427c/apple-min.svg',
    aspectRatio: '25 / 30',
  },
  'black-rock': {
    logoBw:
      '/content/content-images/brand-logos/1e3ed84db81197fbbafb587d261a9804/black-rock-sw-min.svg',
    aspectRatio: '360 / 146',
  },
  epico: {
    logoBw: '/content/content-images/brand-logos/6a83bb2884be766f210980fc7241e0b7/epico-sw-min.svg',
    aspectRatio: '847 / 250',
  },
  cellularline: {
    logoBw:
      '/content/content-images/brand-logos//b36ce2237e987b44c18601e5cd02f389/cellularline-sw-min.svg',
    aspectRatio: '569 / 248',
  },
  huawei: {
    logoBw:
      '/content/content-images/brand-logos/fe49f84781c8b1ce56922bc6752f1431/huawei-sw-min.svg',
    aspectRatio: '2116 / 463',
  },
  fitbit: {
    logoBw:
      '/content/content-images/brand-logos/a4a3684cedbd2c67ca9bee155c20afa7/fitbit-sw-min.svg',
    aspectRatio: '346 / 90',
  },
  jabra: {
    logoBw: '/content/content-images/brand-logos/7d8078572dfa33dc070991ea085e4e2c/jabra-sw-min.svg',
    aspectRatio: '727 / 172',
  },
  lenovo: {
    logoBw:
      '/content/content-images/brand-logos/0681c792749e30d25daed4beeb1c8cb2/lenovo-sw-min.svg',
    aspectRatio: '124 / 40',
  },
  logitech: {
    logoBw:
      '/content/content-images/brand-logos/fd1e8ca7d4140692ffde31a6cd35d7e8/logitech-sw-min.svg',
    aspectRatio: '1000 / 304',
  },
  microsoft: {
    logoBw:
      '/content/content-images/brand-logos/7a0d0f9af107ad491ddf338b0b6027ea/microsoft-sw-min.svg',
    aspectRatio: '338 / 72',
  },
  lg: {
    logoBw: '/content/content-images/brand-logos/823ad534532d48333a565b2c49483f57/lg-sw-min.svg',
    aspectRatio: '580 / 257',
  },
  motorola: {
    logoBw:
      '/content/content-images/brand-logos/3293ea16781ef8874e6f239f127605a5/motorola-sw-min.svg',
    aspectRatio: '2097 / 481',
  },
  sony: {
    logoBw: '/content/content-images/brand-logos/03ef646252d20ce84ab10fd6368bc81f/sony-sw-min.svg',
    aspectRatio: '1280 / 226',
  },
  skullcandy: {
    logoBw:
      '/content/content-images/brand-logos/e9629edabbda96108c8dd25ddd21f409/skullcandy-sw-min.svg',
    aspectRatio: '262 / 48',
  },
  sennheiser: {
    logoBw:
      '/content/content-images/brand-logos/e39c76eb15b26334c8a55ae86b24c21e/sennheiser-sw-min.svg',
    aspectRatio: '1016 / 137',
  },
  soundcore: {
    logoBw:
      '/content/content-images/brand-logos/28564a6cb089da6477231b104708e5c9/soundcore-sw-min.svg',
    aspectRatio: '79 / 15',
  },
  tcl: {
    logoBw: '/content/content-images/brand-logos/34d1d2af96ecaf32310d62f8e33a39e5/tcl-min.svg',
    aspectRatio: '2500 / 780',
  },
  skross: {
    logoBw:
      '/content/content-images/brand-logos/7b3fdeb5d4661543047bc8814011619d/skross-sw-min.svg',
    aspectRatio: '50 / 10',
  },
  'ultimate-ears': {
    logoBw:
      '/content/content-images/brand-logos/bf3cfcbf7fc327e9be34500eda2bb9a3/ultimate-ears-sw-min.svg',
    aspectRatio: '114 / 53',
  },
  wacom: {
    logoBw: '/content/content-images/brand-logos/43b0313e02c9ef3c8a53177a04e1ce44/wacom-sw-min.svg',
    aspectRatio: '1024 / 181',
  },
  syllucid: {
    logoBw:
      '/content/content-images/brand-logos/7c8f024b918e65332413b1bacf0a7af0/syllucid-sw-min.svg',
    aspectRatio: '1507 / 383',
  },
  xlayer: {
    logoBw:
      '/content/content-images/brand-logos/008a8d6880226d6c30c72a0c3e2ef536/xlayer-sw-min.svg',
    aspectRatio: '115 / 47',
  },
  tech21: {
    logoBw:
      '/content/content-images/brand-logos/b2fe92c85d0230196d9b1d11c636faf4/tech-21-sw-min.svg',
    aspectRatio: '863 / 393',
  },
  'white-diamonds': {
    logoBw:
      '/content/content-images/brand-logos/b79b1b3d08044711ebdfaa3fbd215e20/white-diamonds-sw-min.svg',
    aspectRatio: '4939 / 1858',
  },
  aeg: {
    logoBw: '/content/content-images/brand-logos/fb19dbbf83dc5706c40e6f05a694b2fa/aeg.svg',
    aspectRatio: '1053 / 399',
  },
  agi: {
    logoBw: '/content/content-images/brand-logos/0f69c742082ee4c4d303520158bf9530/agi.svg',
    aspectRatio: '204 / 130',
  },
  dbramante1928: {
    logoBw: '/content/content-images/brand-logos/3cecb46e7b510f15ab11314a20a435dc/dbramante.svg',
    aspectRatio: '2422 / 329',
  },
  deqster: {
    logoBw: '/content/content-images/brand-logos/0429358de38052456ebda4521751f0cf/deqster-1.svg',
    aspectRatio: '580 / 533',
  },
  displex: {
    logoBw: '/content/content-images/brand-logos/663af223e3afc3ac227b6b9cd1f2b62b/displex.svg',
    aspectRatio: '572 / 152',
  },
  'fresh-n-rebel': {
    logoBw:
      '/content/content-images/brand-logos/84c6836dab485bf51c9a8b2b3cb0e46d/fresh-n-rebel.svg',
    aspectRatio: '450 / 246',
  },
  nevox: {
    logoBw: '/content/content-images/brand-logos/17c16a84757d29c785e5cbb60e9a7ded/nevox.svg',
    aspectRatio: '443 / 66',
  },
  omelcom: {
    logoBw: '/content/content-images/brand-logos/a4c6f9df74cf2de9afd0fbadb6b0fb14/omelcom.svg',
    aspectRatio: '468 / 179',
  },
  panzerglass: {
    logoBw: '/content/content-images/brand-logos/9c037b465f629e7969aeff6038ab5ece/panzerglass.svg',
    aspectRatio: '445 / 52',
  },
  'peter-jaeckel': {
    logoBw:
      '/content/content-images/brand-logos/438285abd004d75f8ae23685cfd8ae40/peter-jaeckel.svg',
    aspectRatio: '370 / 48',
  },
  pivo: {
    logoBw: '/content/content-images/brand-logos/217c0f83db4cfddefbd4684c91c0c0ff/pivo.svg',
    aspectRatio: '398 / 185',
  },
  vonmaehlen: {
    logoBw: '/content/content-images/brand-logos/d72fd13278ed62fcfd0a070230e97b43/vonmaehlen.svg',
    aspectRatio: '597 / 62',
  },
  woodcessories: {
    logoBw:
      '/content/content-images/brand-logos/3fdb392693d57be052e2ab145d842d0b/woodcessories.svg',
    aspectRatio: '922 / 75',
  },
  xplora: {
    logoBw: '/content/content-images/brand-logos/e1cf27a39c316b5db78cdcc7cdb8f633/xplora.svg',
    aspectRatio: '1493 / 498',
  },
  zens: {
    logoBw: '/content/content-images/brand-logos/7c3ec359d0172c1b21ff616530684873/zens.svg',
    aspectRatio: '945 / 157',
  },
  hmd: {
    logoBw: '/content/content-images/brand-logos/282b5d501b371ee973babb1819b0a2be/hmd-logo-sw.svg',
    aspectRatio: '116 / 50',
  },
  oura: {
    logoBw: '/content/content-images/brand-logos/da99cb58c9ac5e3f3c514c85d8eb5915/Oura-logo.svg',
    logoColor:
      '/content/content-images/brand-logos/color/e468f625417005d0922e19369e057596/Oura-logo.svg',
    aspectRatio: '94 / 30',
  },
  crosscall: {
    logoBw:
      '/content/content-images/brand-logos/c8b0459cf64894312dd2c242d93730c2/crosscall-logo.svg',
    aspectRatio: '411 / 63',
  },
  aqara: {
    logoBw: '/content/content-images/brand-logos/00519b177decf6e165d8ca85969e9c23/aqara-sw.svg',
    aspectRatio: '96 / 28',
  },
  cherry: {
    logoBw: '/content/content-images/brand-logos/fd2bd766081c2c4c938b9f6ceb9cc06e/cherry-logo.svg',
    aspectRatio: '726 / 181',
  },
  anio: {
    logoBw: '/content/content-images/brand-logos/bc6725766627c6e8222194723adac981/anio_logo.svg',
    aspectRatio: '177 / 84',
  },
  ninja: {
    logoBw: '/content/content-images/brand-logos/9dde5723c091418bac253d60e3588959/Ninja_logo.svg',
    aspectRatio: '142 / 65',
  },

  egret: {
    logoBw: '/content/content-images/brand-logos/8f92d1f582b1df2b3c659e61a263d848/egret-logo.svg',
    aspectRatio: '166 / 27',
  },
  delock: {
    logoBw: '/content/content-images/brand-logos/985512e6068de91be3a1e60528dd2f4e/delock-logo.svg',
    aspectRatio: '1285 / 377',
  },
  shark: {
    logoBw: '/content/content-images/brand-logos/a09c6723f6041ae24ec3b663801b3316/shark-logo.svg',
    aspectRatio: '832 / 214',
  },
  narwal: {
    logoBw: '/content/content-images/brand-logos/ce9ca5ecc6bb2316b8de16811abf613c/narwal-logo.svg',
    aspectRatio: '418 / 40',
  },
  sonim: {
    logoBw: '/content/content-images/brand-logos/6562f6116e463972ce6fe04a4268f3b4/sonim–logo.svg',
    aspectRatio: '90 / 34',
  },
  withings: {
    logoBw:
      '/content/content-images/brand-logos/f095d9cc1491b623f3d5f30dfeefc44b/withings-logo.svg',
    aspectRatio: '494 / 64',
  },
  suunto: {
    logoBw: '/content/content-images/brand-logos/a973df23921b1f2de66449a2e1889ae7/suunto-logo.svg',
    aspectRatio: '150 / 49',
  },
  'tp-link': {
    logoBw: '/content/content-images/brand-logos/8eef42d5d6c3c2af843a73a642164f72/tp-link-logo.svg',
    aspectRatio: '105 / 40',
  },
  worx: {
    logoBw:
      '/content/content-images/brand-logos/d9760590f9e9516ca26a59ad3c2e55a9/worx-vector-logo-sw.svg',
    logoColor:
      '/content/content-images/brand-logos/color/cbaf875fb617c31a1b5f1a4d9d21ca0f/worx-vector-logo.svg',
    aspectRatio: '601 / 122',
  },
  schwaiger: {
    logoBw: '/content/content-images/brand-logos/ff95e1f754d1af4b8c6f36d914879e2f/schwaiger.svg',
    aspectRatio: '601 / 122',
  },
  edurino: {
    logoBw: '/content/content-images/brand-logos/d616d44d8fe081a94d5c6533b90536dc/edurino.svg',
    aspectRatio: '1705 / 340',
  },
  '2go': {
    logoBw: '/content/content-images/brand-logos/2f6fc8d095ca3345ec91e98bff66c99e/2go.svg',
    aspectRatio: '456 / 504',
  },
  beats: {
    logoBw: '/content/content-images/brand-logos/45ad975691674a3a26f966faf5a3cb0c/beats.svg',
    aspectRatio: '1 / 1',
  },
  chipolo: {
    logoBw: '/content/content-images/brand-logos/581ac2eec40f1b0640ecd67b44e6003d/chipolo.svg',
    aspectRatio: '246 / 94',
  },
  denver: {
    logoBw: '/content/content-images/brand-logos/df58a16ecdd0e5bb24dec2ccc965ee5a/denver.svg',
    aspectRatio: '1429 / 326',
  },
  imoo: {
    logoBw: '/content/content-images/brand-logos/cde7861f8c70480fd16f0e044af69281/imoo.svg',
    aspectRatio: '1565 / 365',
  },
  mophie: {
    logoBw: '/content/content-images/brand-logos/5bdc23e8c7d42cb4eb00cc767885e02a/mophie-logo.svg',
    aspectRatio: '1500 / 281',
  },
  ecovacs: {
    logoBw: '/content/content-images/brand-logos/9419a6173364d35f127efd5e91a8fdbc/ecovacs-logo.svg',
    aspectRatio: '601 / 172',
  },
  acer: {
    logoBw: '/content/content-images/brand-logos/b5ada89236291622ca0dc71fca085e29/acer.svg',
    aspectRatio: '83 / 20',
  },
  nebula: {
    logoBw:
      '/content/content-images/brand-logos/3c93909f4402eac266c992995c0f158c/NEBULA-by-anker.svg',
    aspectRatio: '3817 / 1027',
  },
  targus: {
    logoBw: '/content/content-images/brand-logos/5809b1545d6bf454796228515b093519/targus.svg',
    aspectRatio: '418 / 80',
  },
  zyxel: {
    logoBw: '/content/content-images/brand-logos/aba1298fe4ab3a13339157f44877418f/zyxel.svg',
    aspectRatio: '132.29 / 29.56',
  },
  '7mind': {
    logoBw: '/content/content-images/brand-logos/80caf66a9407cb42d88e4c0eafd21cfd/7mind.svg',
    aspectRatio: '163 / 80',
  },
  hyper: {
    logoBw: '/content/content-images/brand-logos/e974aa3fc4febde23de8e50be458da09/hyper.svg',
    aspectRatio: '2304 / 394',
  },
  hutt: {
    logoBw: '/content/content-images/brand-logos/d52a619e1f8f2d6709312b0d38fab270/hutt.svg',
    aspectRatio: '217 / 155',
  },
  tomtom: {
    logoBw: '/content/content-images/brand-logos/72ebe2dd9199bf597415d701da29828c/TomTom.svg',
    aspectRatio: '125 / 24',
  },
  telenco: {
    logoBw: '/content/content-images/brand-logos/4ad02427952b932b665c232ca29b430e/telenco.svg',
    aspectRatio: '203 / 46',
  },
  punkt: {
    logoBw: '/content/content-images/brand-logos/2861ef755a14045ffe0697ae94ace440/punkt-logo.svg',
    aspectRatio: '492 / 144',
  },
  nubia: {
    logoBw: '/content/content-images/brand-logos/72a310a1523e0c71ea8fb8d115b6bcfa/nubia-sw.svg',
    logoColor:
      '/content/content-images/brand-logos/color/ea990f5b80b55ad4877aed3d8fd47851/nubia-color.svg',
    aspectRatio: '492.5 / 144.9',
  },
  fritz: {
    logoBw: '/content/content-images/brand-logos/027679dca2e1223dd1482ccf78c72e42/fritz.svg',
    aspectRatio: '392 / 115',
  },
  meta: {
    logoBw: '/content/content-images/brand-logos/6e9c8fa5299677f1c475f45f417feceb/meta-logo-sw.svg',
    logoColor:
      ' /content/content-images/brand-logos/color/afc5ee30eb52ee40311ad52e4c6666ee/meta-logo.svg',
    aspectRatio: '255 / 59',
  },
};
